import { render, staticRenderFns } from "./pages2A.vue?vue&type=template&id=51c89dea&scoped=true&"
import script from "./pages2A.vue?vue&type=script&lang=js&"
export * from "./pages2A.vue?vue&type=script&lang=js&"
import style0 from "./pages2A.vue?vue&type=style&index=0&id=51c89dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c89dea",
  null
  
)

export default component.exports